import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Questionario from './pages/questionario/Questionario';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Home from './pages/home/Home';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <BrowserRouter>
      <div className="App">

        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/questionario" element={<Questionario />} />
          
        </Routes>

      </div>
    </BrowserRouter>
  );
}

export default App;
